import { render, staticRenderFns } from "./SithMesPrdFaultRecordList.vue?vue&type=template&id=36939436&"
import script from "./SithMesPrdFaultRecordList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdFaultRecordList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports